module.exports = __webpack_public_path__ + "img/Weapon_daga_01_mesh.4319acff.png";